(function () {
  function init() {
    var article = document.querySelector('.zzen-article');
    var tocList = document.getElementById('zzen-toc-list');
    if (!article) return;

    // ===== Envolver tablas para scroll horizontal en mobile =====
    article.querySelectorAll('.zzen-body table').forEach(function (table) {
      if (table.parentElement && table.parentElement.classList.contains('zzen-table-wrap')) return;
      var wrap = document.createElement('div');
      wrap.className = 'zzen-table-wrap';
      table.parentNode.insertBefore(wrap, table);
      wrap.appendChild(table);
    });

    if (!tocList) return;

    // ===== Construir TOC =====
    var headings = article.querySelectorAll('.zzen-body h2, .zzen-body h3, .zzen-body h4, .zzen-faqs__title, .zzen-faqs h3');
    if (!headings.length) { var toc = document.querySelector('.zzen-toc'); if (toc) toc.style.display = 'none'; return; }

    var slugCount = {};
    headings.forEach(function (h) {
      var base = h.textContent.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
      var slug = base;
      if (slugCount[base]) { slugCount[base]++; slug = base + '-' + slugCount[base]; } else { slugCount[base] = 1; }
      if (!h.id) h.id = slug;

      var li = document.createElement('li');
      li.className = 'zzen-toc-' + h.tagName.toLowerCase();
      var a = document.createElement('a');
      a.href = '#' + h.id;
      a.textContent = h.textContent;
      li.appendChild(a);
      tocList.appendChild(li);
    });

    // Al hacer click en una entrada de FAQ, abrir el details
    var links = tocList.querySelectorAll('a');
    links.forEach(function (link) {
      link.addEventListener('click', function () {
        var id = link.getAttribute('href').substring(1);
        var target = document.getElementById(id);
        if (target) {
          var parentDetails = target.closest('details.zzen-faq');
          if (parentDetails && !parentDetails.open) parentDetails.open = true;
        }
      });
    });

    // Scroll-spy
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          links.forEach(function (l) { l.classList.toggle('is-active', l.getAttribute('href') === '#' + e.target.id); });
        }
      });
    }, { rootMargin: '-20% 0px -70% 0px' });
    headings.forEach(function (h) { observer.observe(h); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();

